import InsightSwitch from '../Inputs/InsightSwitch';
import { StyledConfigRow } from '../InsightsConfig.style';

const SwitchOnlyInsight = ({ insight, text }) => {
  return (
    <StyledConfigRow>
      <InsightSwitch insight={insight} />
      {text}
    </StyledConfigRow>
  );
};

export default SwitchOnlyInsight;
